import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Youtube, MapPin, Mail, Phone, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A1F44] text-white pt-24 pb-8 relative overflow-hidden" data-id="element-114">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-115">
        <img src="https://cdn.magicpatterns.com/uploads/m6J56ydxbg1oA3N2Z1bP9T/ChatGPT_Image_Mar_16,_2026,_05_56_58_PM.png" alt="" className="w-full h-full object-cover object-center" data-id="element-116" />
        <div className="absolute inset-0 bg-[#0A1F44]/80" data-id="element-117" />
      </div>

      <div className="container-custom relative z-10" data-id="element-118">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-24 mb-20 items-center" data-id="element-119">
          {/* Logo Column */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-120">
            <Link to="/" className="flex items-center gap-4 group mb-4" data-id="element-121">
              <img src="https://cdn.magicpatterns.com/uploads/7J3FrpjsQQtTFpuFCXMBr8/Mar_17__2026__04_26_25_PM-removebg-preview.png" alt="The Household Logo" className="w-14 h-14 rounded-full shrink-0 shadow-lg shadow-red-900/20 object-cover" data-id="element-122" />
              <div className="flex flex-col" data-id="element-123">
                <span className="text-white font-serif text-xl font-bold tracking-wide leading-tight" data-id="element-124">
                  HOUSEHOLD OF
                  <br data-id="element-125" />
                  CHRIST CHURCH
                </span>
                <div className="flex items-center gap-2 text-white/80 text-xs tracking-[0.2em] uppercase mt-1" data-id="element-126">
                  <div className="h-[1px] w-4 bg-[#C8102E]" data-id="element-127"></div>
                  <span data-id="element-128">THE HOUSEHOLD</span>
                  <div className="h-[1px] w-4 bg-[#C8102E]" data-id="element-129"></div>
                </div>
              </div>
            </Link>
          </div>

          {/* Social Links Column */}
          <div className="flex flex-col items-center text-center" data-id="element-130">
            <h3 className="font-bold text-sm tracking-[0.2em] uppercase mb-6 text-white" data-id="element-131">
              STAY CONNECTED
            </h3>
            <div className="flex gap-6" data-id="element-132">
              <a href="https://facebook.com/householdchurch" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[#0A1F44] hover:bg-[#C8102E] hover:text-white transition-colors shadow-lg" aria-label="Facebook" data-id="element-133">
                <Facebook className="w-6 h-6" data-id="element-134" />
              </a>
              <a href="https://youtube.com/@householdchurch" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[#0A1F44] hover:bg-[#C8102E] hover:text-white transition-colors shadow-lg" aria-label="YouTube" data-id="element-135">
                <Youtube className="w-6 h-6" data-id="element-136" />
              </a>
              <a href="https://instagram.com/householdchurch" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[#0A1F44] hover:bg-[#C8102E] hover:text-white transition-colors shadow-lg" aria-label="Instagram" data-id="element-137">
                <Instagram className="w-6 h-6" data-id="element-138" />
              </a>
            </div>
          </div>

          {/* Contact Info Column */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-139">
            <ul className="space-y-4" data-id="element-140">
              <li className="flex items-center gap-4 text-white/90" data-id="element-141">
                <MapPin className="w-5 h-5 text-white shrink-0" data-id="element-142" />
                <span data-id="element-143">1221 Caraway Ct, #1090, Largo, MD 20774</span>
              </li>
              <li className="flex items-center gap-4 text-white/90" data-id="element-144">
                <Phone className="w-5 h-5 text-white shrink-0" data-id="element-145" />
                <a href="tel:301-996-6907" className="hover:text-[#C8102E] transition-colors" data-id="element-146">
                  (301) 996-6907
                </a>
              </li>
              <li className="flex items-center gap-4 text-white/90" data-id="element-147">
                <Mail className="w-5 h-5 text-white shrink-0" data-id="element-148" />
                <a href="mailto:info@householdchurch.org" className="hover:text-[#C8102E] transition-colors" data-id="element-149">
                  info@householdchurch.org
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Tagline & Copyright */}
        <div className="border-t border-white/20 pt-12 flex flex-col items-center gap-6 text-center" data-id="element-150">
          <h2 className="font-script text-2xl md:text-3xl lg:text-4xl text-white mb-4" style={{
          textShadow: '0 2px 10px rgba(0,0,0,0.3)'
        }} data-id="element-151">
            Encounter God • Belong to a Family • Fulfill Your Purpose
          </h2>
          <p className="text-white/60 text-sm" data-id="element-152">
            © {new Date().getFullYear()} Household of Christ Church – All
            Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
}